import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode><App /></React.StrictMode>,
);

// El Service Worker sólo se registra en produccion (requiere HTTPS).
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((reg) => {
        // Buscar versión nueva al abrir y cada media hora. Sin esto,
        // una app instalada puede quedarse semanas en la versión vieja.
        reg.update().catch(() => {});
        setInterval(() => reg.update().catch(() => {}), 30 * 60 * 1000);

        // Cuando llega una versión nueva, se avisa en lugar de
        // recargar a la fuerza: recargar a media captura perdería lo
        // que la persona está escribiendo.
        reg.addEventListener('updatefound', () => {
          const nueva = reg.installing;
          if (!nueva) return;
          nueva.addEventListener('statechange', () => {
            if (nueva.state === 'installed' && navigator.serviceWorker.controller) {
              window.dispatchEvent(new CustomEvent('rinde:version-nueva'));
            }
          });
        });
      })
      .catch(() => {});
  });
}
